<template>
  <div>
    <div class="card p-3" v-show="step === 1">
      <form @submit.prevent="buscarCliente">
        <label class="font-weight-bold mb-0">Pesquisar cliente</label>
        <div class="d-flex mb-3">
          <input type="search" class="form-control mr-2" id="nomePesquisa" placeholder="Pesquisar telefone ou nome" v-model="termoCliente"/>
          <button class="btn btn-outline-dark px-4 mr-1 d-none d-md-inline-block" type="button" title="Limpar pesquisa" :disabled="!termoCliente.length"
                  @click="focusPesquisa(true)">
            <i class="fa fa-times"></i>
          </button>
          <button class="btn btn-warning px-4" title="Pesquisar"><i class="fa fa-search"></i></button>
        </div>
      </form>
      <div class="height-75 container-clientes">
        <div class="row no-gutters cliente-list" v-for="c in clientes" @click="selecionarCliente(c.id_cliente)">
          <div class="col-8">
            <div>{{ c.nome_cliente || ' - ' }}</div>
            <div><b>Telefone:</b> <span v-if="c.telefone">{{ c.telefone | phone }}</span><span v-else>Sem telefone</span></div>
            <div v-if="isNaN(c.email) && c.tipo_cliente === '1'">{{c.email}}</div>
          </div>
          <div class="col-4 text-right">
            <button class="btn btn-third btn-sm" type="button">Selecionar</button>
          </div>
        </div>
        <div class="text-center mt-3 mb-md-3">
          <div v-if="!load && !clientes.length && pesquisou">
            <p class="mb-4">Cliente não encontrado, deseja realizar um novo cadastro?</p>
          </div>
          <button type="button" class="btn btn-outline-primary btn-sm p-3 mr-2" @click="getClienteAtendimento()">Pedido sem cadastro</button>
          <button type="button" class="btn btn-success p-3" @click="novoCliente()">
            <i class="fa fa-user-plus mr-1"></i> Novo cliente
          </button>
        </div>
      </div>
    </div>
    <form @submit.prevent="processarDadosCliente()" v-show="step === 2">
      <loading v-if="load" class="py-4"/>
      <div class="card p-3" v-else>
        <div class="text-center">
          <h6 class="font-weight-bold mb-0">{{ cliente.id_cliente ? 'Editar' : 'Cadastrar' }} Cliente</h6>
          <div class="small">Informe os dados do seu cliente</div>
        </div>
        <hr>
        <div class="row mb-4">
          <div class="col-md-6 mb-2">
            <label class="mb-0 small">Nome do cliente *</label>
            <input type="text" class="form-control" id="nomeCadastro" placeholder="Informe o nome" v-model="cliente.nome_cliente" required/>
          </div>
          <div class="col-md-6 mb-2" v-if="step === 2">
            <label class="mb-0 small">Telefone *</label>
            <the-mask :mask="['(##) ####-####', '(##) #####-####']" class="form-control" id="telefoneCadastro" placeholder="(##) #####-###" v-model="cliente.telefone" required/>
          </div>
          <div class="col-md-6 mb-2" v-if="step === 2">
            <label class="mb-0 small">CPF (opcional)</label>
            <the-mask typeof="number" id="cpf_cnpj" :mask="['###.###.###-##']" class="form-control" placeholder="###.###.###-##" v-model="cliente.cpf"/>
          </div>
          <div class="col-md-6 mb-2" v-if="step === 2">
            <label class="mb-0 small">Data de nascimento (opcional)</label>
            <the-mask id="nascimento" type="tel" :mask="['##/##/####']" class="form-control" v-model="data_nascimento" placeholder="##/##/####"/>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center border-top pt-3">
          <a href="javascript:" @click="cancelarCliente" class="btn btn-outline-dark">Cancelar</a>
          <button class="btn btn-success px-4">{{ cliente.id_cliente ? 'Salvar' : 'Cadastrar' }}</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Loading from "@/components/commons/Loading";

export default {
  name: "ClienteManual",
  components: {Loading},
  props: ['empresa', 'sacola'],
  data() {
    return {
      token: localStorage.getItem('key'),
      load: false,
      clientes: [],
      ref_cliente: '',
      pesquisou: false,
      cliente: { nome_cliente: '', telefone: '', cpf: '', data_nascimento: '', genero: '' },
      data_nascimento: '',
      termoCliente: '',
      step: 1
    }
  },

  methods: {
    editarCliente(cliente) {
      let data_nas = cliente.data_nascimento || '';
      this.data_nascimento = data_nas ? `${data_nas.substring(8, 10)}${data_nas.substring(5, 7)}${data_nas.substring(0, 4)}` : '';

      this.cliente = {
        id_cliente: cliente.id_cliente,
        nome_cliente: cliente.nome_cliente,
        telefone: cliente.telefone,
        data_nascimento: cliente.data_nascimento || '',
        genero: cliente.genero,
        cpf: cliente.cpf || ''
      };

      this.step = 2;
      this.$nextTick(() => {
        this.$helpers.focusElement('nomeCadastro');
      });
    },

    cancelarCliente() {
      this.step = 1;
      this.cliente = { nome_cliente: '', telefone: '' };

      if (this.sacola.cliente && this.sacola.cliente.id_cliente) {
        this.finalizarPedido();

      } else {
        this.focusPesquisa();
      }
    },

    novoCliente() {
      const isPhone = !isNaN(this.termoCliente)
      this.data_nascimento = ''
      this.cliente = {
        nome_cliente: isPhone ? '' : this.termoCliente,
        telefone: isPhone ? this.termoCliente : '' ,
        data_nascimento: '',
        genero: '',
        cpf: ''
      }

      this.step = 2;
      this.$nextTick(() => {
        if (this.cliente.nome_cliente) {
          this.$helpers.focusElement('telefoneCadastro');

        } else {
          this.$helpers.focusElement('nomeCadastro');
        }
      });
    },

    buscarCliente() {
      const termo = this.termoCliente.replace(/\s/g, "").replace(/[-(),]/g,'');
      const isPhone = termo && !isNaN(termo);

      if (!termo) {
        this.$swal({
          text: "Continuar sem o cadastro do cliente?",
          buttons: ['Não', 'Sim']
        }).then((res) => {
          if (res) {
            this.getClienteAtendimento();
          }
        });

        return;
      }

      if (isPhone) {
        if (termo.length < 10) {
          this.$swal('Por favor informe o telefone válido (com DDD) e no mínimo 10 números').then(() => {
            this.focusPesquisa();
          });

          return;
        }

        let pesquisa = termo.replace(/\D/g,'');

        if (pesquisa && pesquisa.startsWith('55')) {
          pesquisa = pesquisa.substring(2, pesquisa.length);
        }

        this.termoCliente = pesquisa;
      }

      const term = this.termoCliente;

      if (!term.trim()) {
        this.$swal(`Por favor informe um nome válido!`).then(() => {
          this.focusPesquisa();
        });

        return;
      }

      this.pesquisou = true;
      this.$store.state.load = "Buscando cliente";
      this.load = true;
      this.clientes = [];
      this.cliente = { nome_cliente: '', telefone: '' };
      const params = { termo: term, id_empresa: this.empresa.id_empresa };

      this.$http.get('v2/pedidos/clientes/' + this.token, { params })
        .then(res => {
          this.load = false;
          this.$store.state.load = false;
          const clientes = res.data || [];

          if (isPhone && clientes.length === 1) {
            this.selecionarCliente(res.data[0].id_cliente);

          } else if (!clientes.length) {
            this.$swal({
              text: `Nenhum cliente encontrado. Deseja realizar seu cadastro?`,
              buttons: ["Não", "Sim"],
              dangerMode: false
            }).then((result) => {
              if (result) {
                this.pesquisou = false;
                this.novoCliente();

              } else {
                this.$helpers.focusElement('nomePesquisa');
              }
            });

          } else {
            this.clientes = clientes;
          }

        }, res => {
          this.$store.state.load = false;
          this.load = false;
        });
    },

    selecionarCliente(id) {
      if (!id) {
        return;
      }

      this.$store.state.load = "Por favor aguarde";

      this.$http.get(`v2/pedidos/clientes/${this.token}?id_cliente=${id}`)
        .then(res => {
          this.load = false;
          this.$store.state.load = false;
          const dados = (res.data && res.data.id_cliente) ? res.data : null;

          if (!dados) {
            this.$swal("Erro ao selecionar cliente");
            return;
          }

          if (dados.telefone) {
            this.finalizarPedido(dados);

          } else {
            this.$swal("Para continuar cadastre um telefone para este cliente.").then(() => {
              this.editarCliente(dados);
            });
          }

        }, res => {
          this.load = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          this.$store.state.load = false;
        });
    },

    processarDadosCliente() {
      if (this.cliente.cpf && !this.validarCpf(this.cliente.cpf)) {
        this.$store.state.load = false;

        this.$swal("Por favor informe um CPF válido ou remova o CPF").then(() => {
          this.$helpers.focusElement("cpf_cnpj")
        });

        return;
      }

      if (this.cliente.telefone.trim().length < 10) {
        this.$swal('Por favor informe o telefone válido (com DDD) e no mínimo 10 números').then(() => {
          this.$helpers.focusElement("telefoneCadastro")
        });

        return;
      }

      if (!this.cliente.nome_cliente.trim()) {
        this.$swal('Por favor informe um nome válido').then(() => {
          this.$helpers.focusElement("nomeCadastro")
        });

        return;
      }

      if (this.data_nascimento) {
        const data_nascimento = this.validarAniversario(this.data_nascimento);

        if (!data_nascimento) {
          this.$swal("Por favor informe uma data de nascimento válida ou remova").then(() => {
            this.$helpers.focusElement("nascimento")
          });

          return;
        }

        this.cliente.data_nascimento = data_nascimento;
      }

      this.load = true;
      this.cliente.id_empresa = this.empresa.id_empresa;
      this.$http.post(`v2/pedidos/cliente/${this.token}`, this.cliente)
        .then(res => {
          this.load = false;

          if (res.data && res.data.id_cliente) {
            this.finalizarPedido(res.data);
          }

        }, res => {
          this.load = false;
          this.$swal(res.data.msg && res.data.msg ? res.data.msg : 'Erro Temporário');
        });
    },

    getClienteAtendimento() {
      if (this.autoatendimento) {
        this.finalizarPedido(JSON.parse(JSON.stringify(this.autoatendimento)));
        return;
      }

      this.$store.state.load = "Por favor aguarde..";
      this.$http.get(`chatbot/autoatendimento/${this.token}?id_empresa=${this.empresa.id_empresa}`)
        .then(res => {
          this.$store.state.load = false;

          if (res.data && res.data.id_cliente) {
            this.autoatendimento = res.data;
            this.autoatendimento.nome_cliente = "";
            this.autoatendimento.id_endereco = null;
            this.finalizarPedido(JSON.parse(JSON.stringify(this.autoatendimento)));
          }

        }, res => {
          this.$store.state.load = false;
        });
    },

    finalizarPedido(cliente) {
      this.$emit('atualizar', cliente);
    },

    focusPesquisa(clear) {
      if (clear) {
        this.step = 1;
        this.clientes = [];
        this.cliente = { nome_cliente: '', telefone: '' };
        this.termoCliente = '';
        this.pesquisou = false;
      }

      this.$nextTick(() => {
        this.$helpers.focusElement('nomePesquisa');
      });
    },

    validarCpf(cpf) {
      if (typeof cpf !== 'string') return false
      cpf = cpf.replace(/[^\d]+/g, '')
      if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false
      cpf = cpf.split('').map(el => +el)
      const rest = (count) => (cpf.slice(0, count-12)
          .reduce( (soma, el, index) => (soma + el * (count-index)), 0 )*10) % 11 % 10
      return rest(10) === cpf[9] && rest(11) === cpf[10]
    },

    validarAniversario(data) {
      if (!data || !/^\d{8}$/.test(data)) return null;
      let dia = parseInt(data.substring(0, 2), 10);
      let mes = parseInt(data.substring(2, 4), 10);
      let ano = parseInt(data.substring(4, 8), 10);
      let dataObj = new Date(ano, mes - 1, dia);
      if (dataObj.getFullYear() !== ano || dataObj.getMonth() + 1 !== mes || dataObj.getDate() !== dia) return null;
      return `${ano}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
    },
  },

  filters: {
    maskPhone(term) {
      if (!term) return "";
      if (isNaN(term)) return term;
      term = term.replace(/\D/g,'')
      term = term.replace(/(\d{2})(\d)/,"($1) $2")
      term = term.replace(/(\d)(\d{4})$/,"$1-$2")
      return term;
    }
  }
}
</script>

<style scoped>
  .cliente-list {
    font-size: 0.8rem;
    border-bottom: 1px solid #e3e6f0;
    padding: 1rem 0;
    align-items: center;
    cursor: pointer;
  }

  .cliente-list:last-child {
    border-bottom: none;
  }

  .container-clientes {
    margin-bottom: 0;
    border-top: 1px solid #e3e6f0;
    height: calc(100vh - 275px);
  }

  @media (min-width: 768px) {
    .container-clientes {
      border: 1px solid #e3e6f0;
      border-radius: 12px;
      padding: 0 1rem;
    }
  }
</style>